(function () {

  function updateCookieInfoButtonLabels(root) {
    root.querySelectorAll('.cc-btn-cookie-info-container').forEach(button => {
      const label = button.closest('label');
      if (!label) return;

      const categoryText = Array.from(label.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();

      if (categoryText) {
        button.setAttribute('aria-label', `Show ${categoryText}`);
      }
    });
  }

  // SWITCH ACCESSIBILITY + KEYBOARD + FOCUS + CONTRAST
  function updateSwitchAccessibility(root) {
    root.querySelectorAll('[role="switch"], .csm-native-switcher').forEach((sw, index) => {

      sw.setAttribute('role', 'switch');

      if (!sw.hasAttribute('tabindex')) {
        sw.setAttribute('tabindex', '0');
      }

      const baseLabel =
        sw.getAttribute('data-base-label') ||
        sw.getAttribute('aria-label')?.replace(/\s+toggle(\s+toggle)*$/i, '') ||
        sw.closest('.csm-native-title-container')
          ?.querySelector('.csm-native-title')
          ?.textContent?.trim();

      if (baseLabel) {
        sw.setAttribute('data-base-label', baseLabel);
        sw.setAttribute('aria-label', `${baseLabel} toggle`);
      }

      const isActive =
        sw.classList.contains('csm-native-switcher-active') ||
        sw.getAttribute('aria-checked') === 'true';

      sw.setAttribute('aria-checked', isActive ? 'true' : 'false');

      // ===== Contrast styles from first script =====
      // if (isActive) {
      //   // ON
      //   sw.style.setProperty('background', '#4F8EF7', 'important');
      //   sw.style.setProperty('border', '2px solid #4F8EF7', 'important');
      //   sw.style.setProperty('opacity', '1', 'important');
      // } else {
      //   // OFF
      //   sw.style.setProperty('background', '#FFFFFF', 'important');
      //   sw.style.setProperty('border', '2px solid #4F8EF7', 'important');
      //   sw.style.setProperty('opacity', '1', 'important');
      // }

      sw.style.setProperty('color', '#1f2937', 'important');
      sw.style.setProperty('font-weight', '600', 'important');

      if (!sw.dataset.keyboardBound) {
        sw.dataset.keyboardBound = "true";

        sw.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            sw.click();
          }
        });

        // Focus ring
        sw.addEventListener('focus', () => {
          sw.style.setProperty('outline', '2px solid #000000', 'important');
          sw.style.setProperty('outline-offset', '2px', 'important');
          sw.style.setProperty('box-shadow', '0 0 0 3px rgba(0,0,0,0.25)', 'important');
        });

        sw.addEventListener('blur', () => {
          sw.style.removeProperty('outline');
          sw.style.removeProperty('outline-offset');
          sw.style.removeProperty('box-shadow');
        });
      }
    });
  }

  // Provider group focus
  function updateProviderGroupFocus(root) {
    root.querySelectorAll('.cookies-info button, .csm-provider-group-header').forEach(el => {

      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }

      if (!el.dataset.focusBound) {
        el.dataset.focusBound = "true";

        el.addEventListener('focus', () => {
          el.style.setProperty('outline', '2px solid #000000', 'important');
          el.style.setProperty('outline-offset', '2px', 'important');
          el.style.setProperty('box-shadow', '0 0 0 3px rgba(0,0,0,0.25)', 'important');
          el.style.setProperty('border-radius', '4px', 'important');
        });

        el.addEventListener('blur', () => {
          el.style.removeProperty('outline');
          el.style.removeProperty('outline-offset');
          el.style.removeProperty('box-shadow');
        });
      }
    });
  }

  function fixDescriptionContrast(root) {
    root.querySelectorAll('.csm-native-description').forEach(el => {
      el.style.setProperty('color', '#1f2937', 'important');
      el.style.setProperty('line-height', '1.5', 'important');
    });
  }

  function fixLinks(root) {
    root.querySelectorAll('.cc-links, a').forEach(link => {
      link.style.setProperty('text-decoration', 'underline', 'important');
      link.style.setProperty('color', '#0b57d0', 'important');
      link.style.setProperty('font-weight', '500', 'important');
    });
  }

  function fixCookieTitles(root) {
    root.querySelectorAll('.csm-native-cookie-title').forEach(el => {
      if (el.tagName.toLowerCase() === 'div') {
        const h2 = document.createElement('h2');

        Array.from(el.attributes).forEach(attr => {
          h2.setAttribute(attr.name, attr.value);
        });

        h2.innerHTML = el.innerHTML;
        el.replaceWith(h2);
      }
    });
  }

  function fixToggleHeaders(root) {
    root.querySelectorAll('.csm-native-title-container').forEach(container => {
      const btn = container.querySelector('button');
      if (!btn) return;

      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const title = container.querySelector('.csm-native-title');

      if (title) {
        title.style.setProperty(
          'color',
          isExpanded ? '#111827' : '#374151',
          'important'
        );
        title.style.setProperty('font-weight', '600', 'important');
      }
    });
  }

  function updateAccessibility(root) {

    const selectors = [
      '.cc-settings.isense-cc-settings',
      '.csm-preferences-button.csm-cookie-button'
    ];

    selectors.forEach(selector => {
      root.querySelectorAll(selector).forEach(btn => {
        btn.setAttribute('role', 'dialog');
        btn.setAttribute('aria-haspopup', 'dialog');
      });
    });

    root.querySelectorAll('a[aria-label]').forEach(link => {
      const ariaLabel = link.getAttribute('aria-label');

      if (
        ariaLabel &&
        ariaLabel.includes('Consentmo logo') &&
        ariaLabel.includes('(opens in a new tab)')
      ) {
        link.setAttribute('aria-label', 'Consentmo (opens in a new tab)');
      }
    });

    root.querySelectorAll('.cc-btn-close-settings').forEach(btn => {
      btn.setAttribute('aria-label', 'Close');
    });

    updateCookieInfoButtonLabels(root);
    updateSwitchAccessibility(root);
    updateProviderGroupFocus(root);
    fixDescriptionContrast(root);
    fixLinks(root);
    fixCookieTitles(root);
    fixToggleHeaders(root);
  }

  function init() {

    const consentHost = document.querySelector('csm-cookie-consent');

    if (!consentHost || !consentHost.shadowRoot) {
      return false;
    }

    const shadowRoot = consentHost.shadowRoot;

    updateAccessibility(shadowRoot);

    if (!shadowRoot._accessibilityObserver) {
      shadowRoot._accessibilityObserver = new MutationObserver(() => {
        updateAccessibility(shadowRoot);
      });

      shadowRoot._accessibilityObserver.observe(shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    return true;
  }

  const pageObserver = new MutationObserver(() => {
    if (init()) {
      pageObserver.disconnect();
    }
  });

  if (!init()) {
    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

})();